import { ApiRequestData, StepIndex } from "../types/types";

const getQuery = (stepNo: StepIndex, data: any): ApiRequestData => {
	let query: ApiRequestData = [];
	switch (stepNo) {
		case 0:
			query = [
				{
					action: "get_clubs",
					query: [],
				},
			];
			break;
		case 1:
			query = [
				{
					action: "get_contact",
					query: [
						{
							name: "email",
							value: data?.email,
						},
					],
				},
			];
			break;
		case 2:
			query = [
				{
					action: "get_membership_types",
					query: [
						{
							name: "clubID",
							value: data?.get_club_id,
						},
						{
							name: "membershipTypeCategory",
							value: data?.isLoggedIn ? "0" : "null",
						},
						{
							name: "billingFrequency",
							value: data?.isLoggedIn ? "0" : "null",
						},
					],
				},
				{
					action: "get_membership_type_frequencies",
					query: [
						{
							name: "clubID",
							value: data?.get_club_id,
						},
					],
				},
				{
					action: "get_membership_type_categories",
					query: [
						{
							name: "clubID",
							value: data?.get_club_id,
						},
					],
				},
				{
					action: "get_contract",
					query: [
						{
							name: "clubID",
							value: data?.get_club_id,
						},
						{
							name: "language",
							value: "en",
						},
					],
				},
				{
					action: "get_contract_fr",
					query: [
						{
							name: "clubID",
							value: data?.get_club_id,
						},
						{
							name: "language",
							value: "fr",
						},
					],
				},
			];
			break;
		case 3:
			query = [
				{
					action: "get_packages",
					query: [
						{
							name: "clubID",
							value: data?.get_club_id,
						},
						{
							name: "membershipTypeId",
							value: data?.selectedMembership?.MembershipTypeId,
						},
						{
							name: "complimentary",
							value: "false",
						},
					],
				},
				{
					action: "get_membership_details",
					query: [
						{
							name: "clubID",
							value: data?.get_club_id,
						},
						{
							name: "membershipTypeId",
							value: data?.selectedMembership?.MembershipTypeId,
						},
						{
							name: "waiveIfee",
							value: 0,
						},
						{
							name: "waiveSS",
							value: 0,
						},
						{
							name: "splitIFee",
							value: data?.splitPayment,
						},
						{
							name: "marketingPromoType",
							value: 0,
						},
					],
				},
			];
			break;
		case 4:
			query = [
				{
					action: "get_salutations",
					query: [],
				},
				{
					action: "get_genders",
					query: [],
				},
				{
					action: "get_marital_statuses",
					query: [],
				},
				{
					action: "get_max_submembers_by_membership_type",
					query: [
						{
							name: "membershipTypeId",
							value: data?.selectedMembership?.MembershipTypeId,
						},
					],
				},
				{
					action: "get_submember_relationships",
					query: [
						{
							name: "membershipTypeId",
							value: data?.selectedMembership?.MembershipTypeId,
						},
					],
				},
				{
					action: "get_submember_age_information",
					query: [
						{
							name: "clubID",
							value: data?.get_club_id,
						},
						{
							name: "membershipTypeId",
							value: data?.selectedMembership?.MembershipTypeId,
						},
					],
				},
				{
					action: "get_min_adult_age",
					query: [
						{
							name: "clubID",
							value: data?.get_club_id,
						},
					],
				},
			];
			break;
	}

	return query;
};

const getQueryValidateZip = (zip: number): ApiRequestData => {
	return [
		{
			action: "validate_zip",
			query: [
				{
					name: "zip",
					value: zip,
				},
			],
		},
	];
};

const getQueryLoginAdvisor = (
	username: string,
	password: string,
): ApiRequestData => {
	return [
		{
			action: "advisor_login",
			query: [
				{
					name: "Username",
					value: username,
				},
				{
					name: "Password",
					value: password,
				},
			],
		},
	];
};

export { getQuery, getQueryLoginAdvisor, getQueryValidateZip };
